import PackagesResource from "./packages.resource";

const packagesModule = angular
  .module("app.resources.packages", [])
  .service("Packages", PackagesResource);

export default packagesModule;



// WEBPACK FOOTER //
// ./src/resources/packages/packages.module.js